import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ConfigService } from './services/config.service';
import { ConfigLoader } from './services/config.loader';

import { AppRoutingModule } from '@/app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from '@modules/main/main.component';
import { LoginComponent } from '@modules/login/login.component';
import { HeaderComponent } from '@modules/main/header/header.component';
import { FooterComponent } from '@modules/main/footer/footer.component';
import { MenuSidebarComponent } from '@modules/main/menu-sidebar/menu-sidebar.component';
import { BlankComponent } from '@pages/blank/blank.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ProfileComponent } from '@pages/profile/profile.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RegisterComponent } from '@modules/register/register.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { ToastrModule } from 'ngx-toastr';
import { MessagesComponent } from '@modules/main/header/messages/messages.component';
import { NotificationsComponent } from '@modules/main/header/notifications/notifications.component';
import { NgxSpinnerModule } from 'ngx-spinner';

import { CommonModule, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { UserComponent } from '@modules/main/header/user/user.component';
import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { LanguageComponent } from '@modules/main/header/language/language.component';
import { MainMenuComponent } from './pages/main-menu/main-menu.component';
import { SubMenuComponent } from './pages/main-menu/sub-menu/sub-menu.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { ControlSidebarComponent } from './modules/main/control-sidebar/control-sidebar.component';
import { StoreModule } from '@ngrx/store';
import { authReducer } from './store/auth/reducer';
import { uiReducer } from './store/ui/reducer';
import { ProfabricComponentsModule } from '@profabric/angular-components';
import { SidebarSearchComponent } from './components/sidebar-search/sidebar-search.component';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { environment } from 'environments/environment';
import { ActivityTabComponent } from './pages/profile/activity-tab/activity-tab.component';
import { TimelineTabComponent } from './pages/profile/timeline-tab/timeline-tab.component';
import { SettingsTabComponent } from './pages/profile/settings-tab/settings-tab.component';
import { PostComponent } from './pages/profile/post/post.component';
import { InfoBoxComponent } from './components/info-box/info-box.component';
import { SmallBoxComponent } from './components/small-box/small-box.component';
import { ContentHeaderComponent } from './components/content-header/content-header.component';
import { LoadingComponent } from './components/loading/loading.component';
import { OverlayLoadingComponent } from './components/overlay-loading/overlay-loading.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HomeComponent } from './pages/website/home/home.component';
import { WebsiteHeaderComponent } from './pages/website/website-header/website-header.component';
import { WebsiteFooterComponent } from './pages/website/website-footer/website-footer.component';
import { AboutComponent } from './pages/website/about/about.component';
import { ContactComponent } from './pages/website/contact/contact.component';
import { ProductsComponent } from './pages/website/products/products.component';
import { FormsModule } from '@angular/forms';
import { AdminProductsComponent } from './pages/website/admin-products/admin-products.component';
import { AdminCategoriesComponent } from './pages/website/admin-categories/admin-categories.component';
import { AdminOrdersComponent } from './pages/website/admin-orders/admin-orders.component';
import { AdminOrdersEnquiriesComponent } from './pages/website/admin-orders-enquiries/admin-orders-enquiries.component';
import { ProductDetailComponent } from './pages/website/product-detail/product-detail.component';

registerLocaleData(localeEn, 'en-EN');

@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        MenuSidebarComponent,
        BlankComponent,
        ProfileComponent,
        RegisterComponent,
        DashboardComponent,
        MessagesComponent,
        NotificationsComponent,
        UserComponent,
        ForgotPasswordComponent,
        RecoverPasswordComponent,
        LanguageComponent,
        MainMenuComponent,
        SubMenuComponent,
        MenuItemComponent,
        ControlSidebarComponent,
        SidebarSearchComponent,
        ActivityTabComponent,
        TimelineTabComponent,
        SettingsTabComponent,
        PostComponent,
        InfoBoxComponent,
        SmallBoxComponent,
        ContentHeaderComponent,
        LoadingComponent,
        OverlayLoadingComponent,
        HomeComponent,
        WebsiteHeaderComponent,
        WebsiteFooterComponent,
        AboutComponent,
        ContactComponent,
        ProductsComponent,
        AdminProductsComponent,
        AdminCategoriesComponent,
        AdminOrdersComponent,
        AdminOrdersEnquiriesComponent,
        ProductDetailComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        ProfabricComponentsModule,
        CommonModule,
        BrowserModule,
        StoreModule.forRoot({ auth: authReducer, ui: uiReducer }),
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-top-right',
            preventDuplicates: true
        }),
        NgxGoogleAnalyticsModule.forRoot(environment.GA_ID),
        FontAwesomeModule,
        RouterModule,
        NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: ConfigLoader,
            deps: [ConfigService],
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
